import { css, cx } from "styled-system/css";
import { Outlet, useNavigate } from "react-router-dom";
import { cf } from "@/components/brand/sfturnos-styles";
import { AdminNav } from "@/components/admin/admin-nav";

export function AdminLayout() {
  const navigate = useNavigate();

  async function signOut() {
    await fetch("/api/auth/logout", { method: "POST", credentials: "include" });
    navigate("/");
    window.location.reload();
  }

  return (
    <div
      className={css({
        minH: "100vh",
        display: "grid",
        gridTemplateColumns: { base: "1fr", md: "280px 1fr" },
      })}
    >
      <aside
        className={cx(
          cf.darkPanel,
          css({
            p: "5",
            position: { md: "sticky" },
            top: { md: "0" },
            h: { md: "100vh" },
            display: "flex",
            flexDir: "column",
            borderRightWidth: { md: "1px" },
            borderColor: "rgba(255,255,255,0.08)",
          }),
        )}
      >
        <div className={cx(cf.darkPanelInner, css({ mb: "6" }))}>
          <p className={css({ fontSize: "xs", letterSpacing: "widest", opacity: 0.65, mb: "2", color: "white" })}>
            SFTURNOS SUPERADMIN
          </p>
          <p className={css({ fontWeight: "bold", fontSize: "lg", color: "white" })}>SFT Development</p>
        </div>
        <div className={cx(cf.darkPanelInner, css({ flex: "1" }))}>
          <AdminNav />
        </div>
        <div className={cx(cf.darkPanelInner, css({ mt: "4" }))}>
          <button
            type="button"
            onClick={() => void signOut()}
            className={css({
              fontSize: "sm",
              color: "#fecaca",
              bg: "transparent",
              borderWidth: "1px",
              borderColor: "rgba(248,113,113,0.45)",
              px: "3",
              py: "2",
              rounded: "md",
              cursor: "pointer",
              width: "100%",
              _hover: { bg: "rgba(248,113,113,0.12)" },
            })}
          >
            Salir
          </button>
        </div>
      </aside>
      <div className={cf.mainArea}>
        <div className={cf.contentMax}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
